export const APPOINTMENT_STATUS = {
    OPEN: "OPEN",
    CLOSED: "CLOSED",
};

export const APPOINTMENT_STATUSES = [
    { id: "OPEN", label: "open", color: "#FAC256" },
    { id: "CLOSED", label: "closed", color: "#ED6969" },
];
